import { Component, Input } from '@angular/core';

import { SharedModule } from '../../_shared/shared.module';

@Component({
  selector: 'app-footer-website',
  templateUrl: './footer-website.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class FooterWebsiteComponent {
  @Input() website;
}
